import {Form, Input, DatePicker, Row, Col, InputNumber, Select} from 'antd';
import React from 'react';
import AddFormComponent from "../common/AddFormComponent";
import EditFormComponent from "../common/EditFormComponent";
import {Arguments} from "../common/Arguments";
import SaveButtonComponent from "../common/SaveButtonComponent";
import {validateWhiteSpace} from "../common/ValidateWhiteSpace";

const {TextArea} = Input;

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};

const tailLayout = {
    wrapperCol: {offset: 4, span: 16},
};

const AddOtherActivity = () => {
    const currentUrl = window.location.href;
    const apiList = [Arguments.host + "/society_organization/society/api!addOtherActivity.do"];

    return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={OtherActivityForm} url={apiList}/> :
        <EditFormComponent UserForm={OtherActivityForm} url={apiList}/>)
}

const OtherActivityForm = ({onFinish, initialValues}) => {
    const [form] = Form.useForm();

    return (
        <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={onFinish}
            initialValues={initialValues}
            style={{maxWidth: 800, marginLeft: 40}}
        >
            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityName" label="活动名称" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activitySubject" label="活动主题" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={12}>
                    <Form.Item name="activityDate" label="活动时间" rules={[{required: true, message: '内容不能为空'}]}>
                        <DatePicker placeholder="选择日期"/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item name="activityScope" label="活动规模" rules={[{required: true, message: '内容不能为空'}]}>
                        <InputNumber min={0} style={{width: 150}}/>
                    </Form.Item>
                </Col>
            </Row>


            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityAddress" label="活动地址" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>


            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityExpert" label="发言嘉宾" rules={[{required: true, message: '内容不能为空'}]}>
                        <TextArea placeholder="请注明发言嘉宾的工作单位！" rows={7}/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="activityMemo" label="活动备注" rules={[{required: true, validator: validateWhiteSpace}]}>
                        <Input/>
                    </Form.Item>
                </Col>
            </Row>

            <Row align="top">
                <Col span={24}>
                    <Form.Item
                        labelCol={{span: 4}}
                        wrapperCol={{span: 20}}
                        name="checkStatus" label="审核状态" rules={[{required: true, message: '内容不能为空'}]}
                        initialValue="未审">
                        <Select disabled={true}>
                            <Select.Option value="通过">通过</Select.Option>
                            <Select.Option value="驳回">驳回</Select.Option>
                            <Select.Option value="未审">未审</Select.Option>
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item {...tailLayout}>
                <SaveButtonComponent />
            </Form.Item>
        </Form>
    );
};

export default AddOtherActivity;
